import { render } from "./MdCard.vue?vue&type=template&id=652ae2e4"
import script from "./MdCard.vue?vue&type=script&lang=js"
export * from "./MdCard.vue?vue&type=script&lang=js"

import "./MdCard.vue?vue&type=style&index=0&id=652ae2e4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__